module.exports = __webpack_public_path__ + "static/media/upload-file.6436f902.svg";